import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchBulkPaymentHistoryFailure,
  fetchBulkPaymentHistoryReq,
  fetchBulkPaymentHistorySuccess,
} from 'redux/slice/allocation/BulkPaymentHistory.slice';
import {
  BulkPaymentHistoryRequest,
  BulkPaymentHistoryResponse,
} from 'redux/types/Allocation.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* fetchBulkPaymentHistory({
  payload,
}: PayloadAction<BulkPaymentHistoryRequest>) {
  try {
    const { allocatorId, page = 1, limit = 10 } = payload;

    const response: { data: BulkPaymentHistoryResponse } =
      yield HTTPClient.GetRequest(
        `${allocationEndpoints.GET_BULK_PAYMENT_HISTORY(
          allocatorId
        )}?page=${page}&limit=${limit}`
      );

    yield put(
      fetchBulkPaymentHistorySuccess({
        data: response.data?.data || [],
        pagination: response.data?.pagination || {
          total_elements: 0,
          page_number: 1,
          limit: 10,
          offset: 0,
        },
      })
    );
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch bulk payment history';
    yield put(fetchBulkPaymentHistoryFailure(errorMessage));
  }
}

export function* watchBulkPaymentHistorySagas() {
  yield takeLatest(fetchBulkPaymentHistoryReq.type, fetchBulkPaymentHistory);
}
